import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 * 
 * @param {*} std 
 * @returns 
 */
const createGradedSTDCoverage = (std) => {
    let stdStr = `Graded scale as follows: You have coverage for ${ std.percentageFirstMax }% of the first $${ helpers.numberWithCommas(std.firstMax) } of weekly earnings`;

    if (std.percentageSecondMax && std.secondMax === 0) {
        stdStr += `, ${ std.percentageSecondMax }% of the remainder`;
        return stdStr;
    }

    if (std.percentageSecondMax && std.secondMax > 0) {
        stdStr += `, ${ std.percentageSecondMax }% of the next $${ helpers.numberWithCommas(std.secondMax) }`;
    }

    if (std.percentageThirdMax) {
        stdStr += `, and ${ std.percentageThirdMax }% of ${ std.thirdMax > 0 ? 'of the next $' : 'the remainder' }${ std.thirdMax ? helpers.numberWithCommas(std.thirdMax) : '' }`;
        return stdStr;
    }

    return stdStr;
};

/**
 *
 * @param {*} props
 */
export default function Std({ classes, expanded, std, handleChange, isStudent }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('std')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('std') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Short Term Disability</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        std.isEligible !== 1 ? 
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    } 

                    {
                        std.isGraded ?
                            <>
                                <Text small bold margin="20px 0px 0px 0px">{createGradedSTDCoverage(std)}</Text>
                                <Text small bold margin="0px 0px 20px 0px">{ std.isTaxable ? 'Taxable' : 'Non-Taxable' }</Text>
                            </>
                            :
                            <>
                                <Text small bold margin="5px 0px 0px 0px">{ `Flat Amount: You have coverage for ${ std.percentageOfFlatAmount }% of weekly Earnings` }</Text>
                                <Text small bold margin="0px 0px 20px 0px">{ std.isTaxable ? 'Taxable' : 'Non-Taxable' }</Text>
                            </>
                    }

                    <div>
                        <Text small margin="5px 0px 0px 0px">
                            { std.maxEvidence > 0 ? `$${ helpers.formatNumber(std.maxEvidence) } Maximum with evidence of insurability.` : null }
                        </Text>

                        <Text small margin="5px 0px 0px 0px">
                            { std.maxNoEvidence > 0 ? `$${ helpers.formatNumber(std.maxNoEvidence) } Maximum with non-evidence of insurability.` : null }
                        </Text>

                        <Text small margin="5px 0px 0px 0px">{ `${ std.elimPeriodAccident } Day Elimination Period for Accidents` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `${ std.elimPeriodHospital } Day Elimination Period for Hospital` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `${ std.elimPeriodSickness } Day Elimination Period for Sickness` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ std.defOfDisability ? std.defOfDisability : null }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `${ std.benefitsPeriod } Week Benefits Period` }</Text>

                        {
                            isStudent ?
                                <Text small margin="5px 0px 0px 0px">
                                    { `Terminates at age ${ std.terminationAge } or date of participants study if earlier.` }
                                </Text>
                                :
                                <Text small margin="5px 0px 0px 0px">
                                    { `Terminates at age ${ std.terminationAge } or date of participants retirement if earlier.` }
                                </Text>
                        }
                    </div>

                </AccordionDetails>
            </Accordion>
        </div>
    );
}